import {
  Id,
  Identifiable,
  Project,
  resource as resourceMock,
  list as listMock,
  task as taskMock,
  Resource,
  project as projectMock,
  ProjectResource,
  ResourceAllocations,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
type ResponseList = {
  uuid: Id;
  name: string;
  subActivities: ResponseList[];
  tasks: {
    uuid: Id;
    name: string;
  }[];
};

type Response = {
  resource: {
    uuid: Id;
    name: string;
    profession: string;
    activityRoot: ResponseList;
  };
};

function formatList(
  list: ResponseList,
  project: Identifiable<Project>,
  resource: Identifiable<Resource>,
): ResourceAllocations["resource"]["lists"][number] {
  return {
    ...listMock,
    ...list,
    project: { ...projectMock, ...project },
    subLists: list.subActivities.map((subList) =>
      formatList(subList, project, resource),
    ),
    tasks: list.tasks.map((task) => ({
      ...taskMock,
      ...task,
    })),
  };
}

function responseToResourceAllocations(
  res: Response,
  project: Identifiable<Project>,
): ResourceAllocations {
  return {
    resource: {
      ...resourceMock,
      ...res.resource,
      lists: [res.resource.activityRoot].map((list) =>
        formatList(list, project, { ...resourceMock, ...res.resource }),
      ),
    },
  };
}

function getProjectResourceAllocations(httpClient: HttpClient) {
  return (
    project: Identifiable<Project>,
    projectResource: Identifiable<ProjectResource>,
  ) => {
    return httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${project.uuid}/resource/${projectResource.uuid}/activities`,
        method: HttpMethods.GET,
      })
      .then((timesheet) => responseToResourceAllocations(timesheet, project));
  };
}

export { getProjectResourceAllocations };
